import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from "../../../services/session";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";
import AutocompleteObject from '../../Shared/AutocompleteObject';
import JSZip from 'jszip';
// import Tesseract from 'tesseract.js';

const AdminApiService = new AdminApi()
const LocService = new Loc()
const KP_ENUM_KIND = ['goods', 'service', 'job'];
const KP_ENUM_TYPE = ['sell', 'buy'];
const KP_ENUM_CONDITION = ['new', 'as-new', 'used', 'damaged'];
const KP_ENUM_CURRENCY = ['eur', 'rsd'];
const KP_SHARE_BASE_URL = 'https://kupujemprodajem.com/';
const KP_DEFAULT_DESCRIPTION_TEMPLATE = `**(Poziv, SMS, Viber, WhatsApp) Aleksandar

ZA NAJBRŽI ODGOVOR POZOVITE (poziv do 20h)

Molimo Vas budite što brži i precizniji sa upitom zbog velikog broja poziva

------------------------------------------------------------------------------------------------------------**
**

**

**• moguće lično preuzimanje u Novom Sadu ili slanje kurirskim službama**

• moguća zamena za Samsung, iPhone, Xiaomi, Huawei i ostale popularne marke telefona

**• moguće plaćanje u kripto valutama**

**------------------------------------------------------------------------------------------------------------**

• imamo sve NOVE telefone po narudžbi

• POZOVITE ZA KOMPLETNU PONUDU uređaja
(poziv, SMS, Viber, WhatsApp) Aleksandar

VRŠIMO I OTKUP NOVIH I POLOVNIH MOBILNIH TELEFONA PO NAJVIŠIM CENAMA`;

function normalizeEnumValue(value, allowedValues) {
    if (value == null || value === '') return null;
    const normalized = String(value).toLowerCase();
    return allowedValues.indexOf(normalized) !== -1 ? normalized : value;
}

function normalizeYesNoValue(value) {
    if (value == null || value === '') return null;
    if (value === true || value === 1 || value === '1') return 'yes';
    if (value === false || value === 0 || value === '0') return 'no';
    const normalized = String(value).toLowerCase();
    if (normalized === 'yes' || normalized === 'true') return 'yes';
    if (normalized === 'no' || normalized === 'false') return 'no';
    return value;
}

function normalizeNullableNumber(value) {
    if (value == null || value === '') return null;
    const asNumber = Number(value);
    return Number.isNaN(asNumber) ? value : asNumber;
}

function normalizeBuyDateForRequest(value) {
    if (value == null) return null;
    const raw = String(value).trim();
    if (raw.length === 0) return null;
    if (raw === 'T08:00:00.000Z') return null;
    if (raw.indexOf('T08:00:00.000Z') > -1) return raw;
    return raw + 'T08:00:00.000Z';
}

function escapeHtml(value) {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function preserveSpacesForHtml(value) {
    return value.replace(/ {2,}/g, (match) => {
        if (match.length <= 1) return match;
        return ' ' + '&nbsp;'.repeat(match.length - 1);
    });
}

function normalizeKpDescriptionRaw(value) {
    const normalizedLineBreaks = value.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    const withoutBom = normalizedLineBreaks.replace(/\uFEFF/g, '');
    const withoutDirectionMarks = withoutBom.replace(/[\u200E\u200F]/g, '');
    const withoutControlChars = withoutDirectionMarks.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '');
    return withoutControlChars.normalize ? withoutControlChars.normalize('NFC') : withoutControlChars;
}

function buildKpIdTag(articleId) {
    if (articleId == null || articleId === '') return '';
    const idNum = Number(articleId);
    if (Number.isNaN(idNum)) return '';
    return '#' + String(Math.trunc(idNum)).padStart(6, '0');
}

function ensureKpDescriptionHasIdAtBottom(rawDescription, articleId) {
    const idTag = buildKpIdTag(articleId);
    if (idTag.length === 0) return rawDescription;

    const trimmedEnd = rawDescription.replace(/\s+$/g, '');
    if (new RegExp(idTag.replace('#', '\\#') + '$').test(trimmedEnd)) {
        return trimmedEnd;
    }

    return trimmedEnd + '\n\n' + idTag;
}

function formatKpDescriptionLineToHtml(line) {
    const tabsAsSpaces = String(line).replace(/\t/g, '    ');
    const escaped = escapeHtml(tabsAsSpaces);
    return preserveSpacesForHtml(escaped);
}

function applyKpInlineEditorFormatting(htmlValue) {
    if (!hasValue(htmlValue)) return htmlValue;

    // **text** => <b>text</b>, supports multi-line content (already converted to <br />)
    let formatted = htmlValue.replace(/\*\*([\s\S]+?)\*\*/g, '<b>$1</b>');
    // *text* => <em>text</em> (single-line intent)
    formatted = formatted.replace(/(^|[^*])\*([^*\r\n<]+)\*(?!\*)/g, '$1<em>$2</em>');
    return formatted;
}

function wrapSelectionWithInlineToken(text, selectionStart, selectionEnd, token) {
    const start = Math.min(selectionStart, selectionEnd);
    const end = Math.max(selectionStart, selectionEnd);
    const selected = text.slice(start, end);
    const hasSelectedText = selected.length > 0;
    const wrappedSelection = token + selected + token;
    const nextText = text.slice(0, start) + wrappedSelection + text.slice(end);

    let nextSelectionStart = start + token.length;
    let nextSelectionEnd = nextSelectionStart + selected.length;
    if (!hasSelectedText) {
        nextSelectionEnd = nextSelectionStart;
    }

    return {
        nextText,
        nextSelectionStart,
        nextSelectionEnd
    };
}

function applyKpInlineFormat(kind) {
    const token = kind === 'bold' ? '**' : '*';
    const editor = this.$refs.kpDescriptionEditor;
    if (!editor) return;

    const currentValue = this.model && this.model.kpDescription != null
        ? String(this.model.kpDescription)
        : '';
    const selectionStart = typeof editor.selectionStart === 'number' ? editor.selectionStart : currentValue.length;
    const selectionEnd = typeof editor.selectionEnd === 'number' ? editor.selectionEnd : selectionStart;

    const result = wrapSelectionWithInlineToken(currentValue, selectionStart, selectionEnd, token);
    this.model.kpDescription = result.nextText;

    this.$nextTick(() => {
        const currentEditor = this.$refs.kpDescriptionEditor;
        if (!currentEditor) return;
        currentEditor.focus();
        currentEditor.setSelectionRange(result.nextSelectionStart, result.nextSelectionEnd);
    });
}

function formatKpDescriptionForRequest(value, articleId) {
    if (value == null) return null;

    // Ako u editor dospeju stari HTML entiteti (&zcaron; itd),
    // prvo ih dekodiramo u prava UTF-8 slova pre slanja.
    const decodedInput = decodeHtmlEntities(String(value));
    const normalized = normalizeKpDescriptionRaw(decodedInput);
    const withId = ensureKpDescriptionHasIdAtBottom(normalized, articleId);
    if (withId.trim().length === 0) return null;

    const lines = withId.split('\n');
    while (lines.length > 0 && lines[0].trim().length === 0) lines.shift();
    while (lines.length > 0 && lines[lines.length - 1].trim().length === 0) lines.pop();

    const htmlLines = lines.map((line) => {
        if (line.trim().length === 0) return '&nbsp;';
        return formatKpDescriptionLineToHtml(line);
    });

    const joinedHtml = htmlLines.join('<br />');
    const formattedHtml = applyKpInlineEditorFormatting(joinedHtml);
    const bodyHtml = '<div>' + formattedHtml + '</div>';
    return '<!DOCTYPE html><html><head><meta charset="UTF-8"></head><body>' + bodyHtml + '</body></html>';
}

function decodeHtmlEntities(value) {
    if (value == null) return '';
    const source = String(value);

    if (typeof document !== 'undefined') {
        const el = document.createElement('textarea');
        el.innerHTML = source;
        return el.value;
    }

    return source
        .replace(/&#(\d+);/g, (m, dec) => String.fromCharCode(Number(dec)))
        .replace(/&#x([0-9a-fA-F]+);/g, (m, hex) => String.fromCharCode(parseInt(hex, 16)))
        .replace(/&nbsp;/g, ' ')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&');
}

function formatKpDescriptionForDisplay(value) {
    if (value == null) return null;
    const raw = String(value);
    if (raw.trim().length === 0) return '';

    const withParagraphs = raw
        .replace(/<\s*(b|strong)(\s+[^>]*)?>/gi, '**')
        .replace(/<\s*\/\s*(b|strong)\s*>/gi, '**')
        .replace(/<\s*(i|em)(\s+[^>]*)?>/gi, '*')
        .replace(/<\s*\/\s*(i|em)\s*>/gi, '*')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>\s*<p[^>]*>/gi, '\n\n')
        .replace(/<p[^>]*>/gi, '')
        .replace(/<\/p>/gi, '')
        .replace(/<\/div>\s*<div[^>]*>/gi, '\n\n')
        .replace(/<div[^>]*>/gi, '')
        .replace(/<\/div>/gi, '');

    const withoutTags = withParagraphs.replace(/<[^>]+>/g, '');
    const decoded = decodeHtmlEntities(withoutTags);
    const normalized = decoded
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n')
        .replace(/\u200E/g, '')
        .replace(/\u200F/g, '');

    return normalized.trim();
}

function normalizeKpPark(value) {
    if (value === true || value === 'true' || value === 1 || value === '1') return true;
    return false;
}

function resolveBackendErrorMessage(error, fallbackMessage) {
    const payload = error && error.data ? error.data : {};
    const base =
        payload.localized_error_message ||
        payload.message ||
        payload.error_description ||
        fallbackMessage;
    const detailsData = Array.isArray(payload.data)
        ? payload.data.filter((x) => x != null && String(x).trim().length > 0)
        : [];
    const detailsErrors = Array.isArray(payload.errors)
        ? payload.errors.filter((x) => x != null && String(x).trim().length > 0)
        : [];
    const details = detailsData.concat(detailsErrors).join('\n');
    return details ? (base + '\n\n' + details) : base;
}

function hasValue(value) {
    return value != null && String(value).trim().length > 0;
}

function parseDateValue(rawValue) {
    if (!hasValue(rawValue)) return null;

    if (rawValue instanceof Date) {
        return Number.isNaN(rawValue.getTime()) ? null : rawValue;
    }

    if (typeof rawValue === 'number') {
        const millis = rawValue > 9999999999 ? rawValue : rawValue * 1000;
        const d = new Date(millis);
        return Number.isNaN(d.getTime()) ? null : d;
    }

    const raw = String(rawValue).trim();
    if (raw.length === 0) return null;
    if (/^\d+$/.test(raw)) {
        const numeric = Number(raw);
        if (Number.isNaN(numeric)) return null;
        const millis = numeric > 9999999999 ? numeric : numeric * 1000;
        const d = new Date(millis);
        return Number.isNaN(d.getTime()) ? null : d;
    }

    const parsed = new Date(raw);
    if (!Number.isNaN(parsed.getTime())) return parsed;

    const m = raw.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (m) {
        const d = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
        return Number.isNaN(d.getTime()) ? null : d;
    }

    return null;
}

function getDifferenceDaysFromToday(dateValue) {
    const parsed = parseDateValue(dateValue);
    if (parsed == null) return null;

    const today = new Date();
    const startToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const startDate = new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    const diffMs = startToday.getTime() - startDate.getTime();
    return Math.max(0, Math.floor(diffMs / 86400000));
}

function sanitizeFileName(value, fallback) {
    const raw = hasValue(value) ? String(value) : String(fallback || 'image');
    return raw.replace(/[<>:"/\\|?*\x00-\x1F]/g, '_').replace(/\s+/g, ' ').trim();
}

function getFileNameFromContentDisposition(headerValue) {
    if (!hasValue(headerValue)) return null;
    const value = String(headerValue);
    const utfMatch = value.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (utfMatch && utfMatch[1]) {
        try {
            return decodeURIComponent(utfMatch[1].replace(/["']/g, ''));
        } catch (e) {
            return utfMatch[1].replace(/["']/g, '');
        }
    }
    const normalMatch = value.match(/filename\s*=\s*("?)([^";]+)\1/i);
    if (normalMatch && normalMatch[2]) return normalMatch[2];
    return null;
}

function extensionFromContentType(contentType) {
    const type = hasValue(contentType) ? String(contentType).toLowerCase() : '';
    if (type.indexOf('image/jpeg') !== -1 || type.indexOf('image/jpg') !== -1) return 'jpg';
    if (type.indexOf('image/png') !== -1) return 'png';
    if (type.indexOf('image/webp') !== -1) return 'webp';
    if (type.indexOf('image/gif') !== -1) return 'gif';
    if (type.indexOf('image/bmp') !== -1) return 'bmp';
    if (type.indexOf('image/svg+xml') !== -1) return 'svg';
    return null;
}

export default {
    data() {
        return {
            idToEdit: null,
            title: LocService.t('label_add_article'),
            locale: LocService,
            barcodeResult: '',
            showChooseImeiDialog: false,
            showChooseImeiOptions: [],
            showCropImageDialog: false,
            fileToCrop: null,
            companiesPayments: [],
            showQrCodeScanner: false,
            namesForPartner: LocService.t('label_name_for_partner'),
            allCategories: [],
            categories: [],
            imeiLabels: [LocService.t('label_a_code'), LocService.t('label_a_code_serial')],
            imeiType: 'number',
            selectedImeiItem: LocService.t('label_a_code'),
            selectedSubCategories: [],
            colorsByCategory: [],
            ramMemories: ['2','3','4','6','8','12','16','24','32'],
            romMemories: ['16','32','64','128','256','512','1024'],
            newSelectedCategory: '',
            newSelectedSubCategory: '',
            visibleCategory: true,
            visibleSubCategory: true,
            visibleStock: true,
            visibleCropContainer: false,
            regularType: 0,
            regularTypes: [
                {
                    id: 0,
                    label: LocService.t('label_regular_sell')
                },
                {
                    id: 1,
                    label: LocService.t('label_regular_supply')
                },
            ],
            model: {
                name: '',
                code: '',
                mainCategory: '',
                subCategory: '',
                addInfoMemory: '',
                ramMemory: '',
                color: '',
                comment: '',
                stockNumber: 1,
                sellingPrice: 0,
                purchasePrice: 0,
                purchasePriceRsd: 0,
                shortDescription: '',
                onService: false,
                sentByPost: false,
                makeScheduleItem: false,
                regularSupply: false,
                lastInventoryTimestamp: null,
                updateAlreadyExist: null,
                isNewArticle: false,

                // KP fields
                kpAdId: null,
                kpKind: null,
                kpGroupSuggestText: null,
                kpCategoryId: null,
                kpGroupId: null,
                kpType: null,
                kpPrice: null,
                kpCurrency: null,
                kpPriceText: null,
                kpPriceFixed: null,
                kpDescription: null,
                kpCondition: null,
                kpImmediateAvailable: null,
                kpExchange: null,
                kpLocationId: null,
                kpOwner: null,
                kpPhone: null,
                kpLocalPickup: null,
                kpCourierDelivery: null,
                kpShareUrl: null,
                kpLastSyncedAt: null,
                kpPostDate: null,
                kpPark: false,
            },
            articleImages: [],
            primaryImageLocalId: null,
            uploadSessionId: null,
            selectedImageLocalId: null,
            showKpPanel: false,
            showKpMoreDetails: false,
            isHydratingArticleModel: false,
            // KP dropdown data
            kpCategories: [],
            kpGroups: [],
            kpLoadingCategories: false,
            kpLoadingGroups: false,
            kpActionLoading: false,
            kpActionType: null,
            kpImportId: '',
            kpImportLoading: false,
            imageOrderDirty: false,
            imageOrderSaving: false,
            downloadImagesZipLoading: false,
            // KP option lists
            kpKindOptions: [
                { value: 'goods', label: LocService.t('label_kp_kind_goods') },
                { value: 'service', label: LocService.t('label_kp_kind_service') },
                { value: 'job', label: LocService.t('label_kp_kind_job') },
            ],
            kpTypeOptions: [
                { value: 'sell', label: LocService.t('label_kp_type_sell') },
                { value: 'buy', label: LocService.t('label_kp_type_buy') },
            ],
            kpYesNoOptions: [
                { value: 'yes', label: LocService.t('label_yes') },
                { value: 'no', label: LocService.t('label_no') },
            ],
            kpConditionOptions: [
                { value: 'new', label: LocService.t('label_kp_condition_new') },
                { value: 'as-new', label: LocService.t('label_kp_condition_as_new') },
                { value: 'used', label: LocService.t('label_kp_condition_used') },
                { value: 'damaged', label: LocService.t('label_kp_condition_damaged') },
            ],
            kpCurrencyOptions: [
                { value: 'eur', label: 'EUR' },
                { value: 'rsd', label: 'RSD' },
            ],
        }
    },
    components: { AutocompleteObject},
    methods: {
        addArticle : addArticle,
        deleteCategory : deleteCategory,
        formatDate : formatDate,
        handleFileChange : handleFileChange,
        addCategories : addCategories,
        deleteSubCategory : deleteSubCategory,
        loadCategories: loadCategories,
        getChipClass: getChipClass,
        getChipClassImei: getChipClassImei,
        getChipClassSub: getChipClassSub,
        isSelectedColor: isSelectedColor,
        getColorClass: getColorClass,
        isSelectedImei: isSelectedImei,
        isSelected: isSelected,
        isSelectedSub: isSelectedSub,
        getById: getById,
        editArticle: editArticle,
        deleteSaradnik: deleteSaradnik,
        clear : clear,
        onSelectImeiType : onSelectImeiType,
        askToEdit : askToEdit,
        showLoading: showLoading,
        recognizeFromImage: recognizeFromImage,
        recognizeFromCrop: recognizeFromCrop,
        showCropImage: showCropImage,
        getChipClassRegularType: getChipClassRegularType,
        isSelectedRegularType: isSelectedRegularType,
        deleteColorCategory: deleteColorCategory,
        updateColorsByCategory: updateColorsByCategory,
        changeArticleInventory: changeArticleInventory,
        openImagePicker: openImagePicker,
        onImagesSelected: onImagesSelected,
        uploadSingleImage: uploadSingleImage,
        setPrimaryImage: setPrimaryImage,
        removeImage: removeImage,
        loadImagesForArticle: loadImagesForArticle,
        selectImage: selectImage,
        openZoomDialog: openZoomDialog,
        onMainImageClick: onMainImageClick,
        moveImageLeft: moveImageLeft,
        moveImageRight: moveImageRight,
        saveImagesOrder: saveImagesOrder,
        downloadAllImagesZip: downloadAllImagesZip,
        toggleKpPanel: toggleKpPanel,
        toggleKpMoreDetails: toggleKpMoreDetails,
        loadKpCategories: loadKpCategories,
        loadKpGroups: loadKpGroups,
        buildKpShareUrl: buildKpShareUrl,
        copyKpShareUrl: copyKpShareUrl,
        publishKpAd: publishKpAd,
        importKpAdFromManualId: importKpAdFromManualId,
        importKpAdIdOnlyFromManualId: importKpAdIdOnlyFromManualId,
        updateKpAdAction: updateKpAdAction,
        unlinkKpAd: unlinkKpAd,
        parkKpAd: parkKpAd,
        unparkKpAd: unparkKpAd,
        deleteKpAd: deleteKpAd,
        applyKpInlineFormat: applyKpInlineFormat,
        getKpPostDateDisplay: getKpPostDateDisplay,
        getKpAdAgeDaysDisplay: getKpAdAgeDaysDisplay,
        handleKpPostCreateDialog: handleKpPostCreateDialog,
        tryAutoSelectKpGroupByMainCategory: tryAutoSelectKpGroupByMainCategory,
        showInventory(){
            return (session.getRole() === 'ROLE_ADMIN' || session.getRole() === 'ROLE_SUPER_ADMIN') && this.idToEdit != null;
        }
    },

    mounted() {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.defer = true;
        recaptchaScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/tesseract.js/4.1.1/tesseract.min.js')
        document.head.appendChild(recaptchaScript)


        let _self = this;
        // window.addEventListener("load",  () => {
        //     const input = document.getElementById('select');
        //     input.addEventListener('change', (e) => {
        //         const file = e.target.files[0];
        //         const reader = new FileReader();
        //         reader.onload = () => {
        //             _self.showCropImage(reader.result)
        //         };
        //
        //         reader.readAsDataURL(file);
        //     });
        //
        //     // _self.cropImage()
        //     // await _self.recognizeFromImage()
        // });


        this.$topnavbar.$on('closeCropImage', () => {
            _self.showCropImageDialog = false;
            _self.fileToCrop = null;
            this.$refs.fileInput.value = null;
        });

        this.$topnavbar.$on('closeChoseImei', () => {
            _self.showChooseImeiDialog = false;
            _self.showChooseImeiOptions = [];
            this.$refs.fileInput.value = null;
        });

        this.$topnavbar.$on('croppedImage', (data) => {
            _self.showCropImageDialog = false;
            _self.fileToCrop = null;
            _self.recognizeFromCrop(data)
            this.$refs.fileInput.value = null;
        });

        this.$topnavbar.$on('selectedImei', (data) => {
            _self.showChooseImeiDialog = false;
            _self.showChooseImeiOptions = [];
            _self.model.code = data;
            this.$refs.fileInput.value = null;
        });
    },

    computed: {
        primaryImage() {
            if (!this.articleImages || this.articleImages.length === 0) return null;
            var found = null;
            for (var i = 0; i < this.articleImages.length; i++) {
                if (this.articleImages[i].localId === this.primaryImageLocalId) { found = this.articleImages[i]; break; }
            }
            return found || this.articleImages[0];
        },
        primaryImageUrl() {
            return (this.primaryImage && this.primaryImage.url) ? this.primaryImage.url : '';
        },
        primaryIsPrimary() {
            return !!(this.primaryImage && this.primaryImage.isPrimary);
        },
        isAnyUploading() {
            var list = this.articleImages || [];
            for (var i = 0; i < list.length; i++) if (list[i].uploading) return true;
            return false;
        },
        selectedImage() {
            // ako ništa nije selektovano, koristi primary
            if (!this.articleImages || this.articleImages.length === 0) return null;

            var id = this.selectedImageLocalId || this.primaryImageLocalId;
            if (!id) return this.articleImages[0];

            for (var i = 0; i < this.articleImages.length; i++) {
                if (this.articleImages[i].localId === id) return this.articleImages[i];
            }
            return this.articleImages[0];
        },
        selectedImageUrl() {
            return (this.selectedImage && this.selectedImage.url) ? this.selectedImage.url : '';
        },
        selectedIsPrimary() {
            return !!(this.selectedImage && this.selectedImage.isPrimary);
        },
        canReorderImages() {
            if (!this.idToEdit) return false;
            if (this.isAnyUploading) return false;
            if (!this.articleImages || this.articleImages.length <= 1) return false;
            for (var i = 0; i < this.articleImages.length; i++) {
                if (this.articleImages[i].serverId == null) return false;
            }
            return true;
        }
    },

    beforeMount() {
        if(session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.idToEdit = this.$route.query.id;
        if(this.idToEdit != null){
            this.showKpPanel = false;
            this.getById()
            this.visibleStock = false
            this.title = LocService.t('label_update_article');
        }else{
            this.model.buyDate = this.$moment(new Date()).format('YYYY-MM-DD')
        }
        this.loadCategories();
        this.loadImagesForArticle();
        this.loadKpCategories();
    },
    watch: {
        'model.color'(newVal, oldVal) {
            this.$topnavbar.$emit('newItemSetToAutocompleteColorAutoComplete', newVal);
        },
        newSelectedCategory: function (val, old){
            this.visibleCategory = val == null
            if(val != null){
                this.selectedSubCategories = this.allCategories.filter(e => e.parentCategory === val).map(m => m.name);
                let foundCategory = this.allCategories.filter(e => e.name === val)
                if(foundCategory.length > 0){
                    let cat = foundCategory[0];
                    console.log(cat)
                    if(cat.color == null || cat.color.length === 0){
                        this.colorsByCategory = []
                    }else{
                        let c = cat.color.split(";").filter(s=> s != null && s.length > 0)
                        this.colorsByCategory = c;
                    }

                }else{
                    this.colorsByCategory = []
                }
            }else{
                this.selectedSubCategories = [];
                this.colorsByCategory = []
            }
        },

        newSelectedSubCategory: function (val, old){
            this.visibleSubCategory = val == null
        },

        'model.kpCategoryId'(val, oldVal) {
            if (val === oldVal) return;
            if (this.isHydratingArticleModel) {
                if (val != null) {
                    this.loadKpGroups(val);
                }
                return;
            }
            if (this.model.kpCategoryId == null) {
                this.model.kpGroupId = null;
                this.kpGroups = [];
                return;
            }
            this.model.kpGroupId = null;
            if (val != null) {
                this.loadKpGroups(val);
            }
        },
    }
}

function deleteColorCategory(){
    console.log(this.newSelectedCategory)
    let foundCategory = this.allCategories.find(e => e.name === this.newSelectedCategory)
    console.log(foundCategory)
    if(foundCategory == null) return
    if(this.model.color == null) return
    if(this.model.color.length === 0) return

    let _self = this;
    swal({
        title:  LocService.t('label_are_you_sure'),
        text:  LocService.t('label_color_delete_are_you_sure') + ": " + this.model.color + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        let model = {
            id: foundCategory.id,
            color: _self.model.color
        }
        AdminApiService.deleteArticleColorFromCategory(model)
            .then((response) => {
                _self.loadCategories();
                _self.colorsByCategory = _self.colorsByCategory.filter(c => c !== model.color)
                _self.model.color = ''
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });

}

function onSelectImeiType(item){
    this.selectedImeiItem = item;
    this.model.code = ''
    if(this.selectedImeiItem === LocService.t('label_a_code')){
        this.imeiType = 'number'
    }else{
        this.imeiType = 'text'
    }
}

function askToEdit(id){
    let _self = this;
    swal({
        title:  LocService.t('label_article_already_exist'),
        text:  LocService.t('label_article_are_you_sure_update_already') + " "+ LocService.t('label_internal_code')+ ": " + String(id).padStart(6, '0'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        _self.idToEdit = id;
        _self.model.updateAlreadyExist = true;
        _self.editArticle(true);

    });
}

function deleteCategory(){
    this.newSelectedCategory = null;
    this.newSelectedSubCategory = null;
}


function showCropImage(file){
    this.fileToCrop = file;
    this.showCropImageDialog = true;
}

function deleteSubCategory(){
    this.newSelectedSubCategory = null;
}

function addCategories(){
    this.$router.push('/article-categories')
}

function loadCategories() {
    let _self = this;

    AdminApiService.getArticleCategories()
        .then((response) => {
            _self.allCategories = response.data;
            session.saveArticleCategories(_self.allCategories)
            _self.categories =  _self.allCategories.filter(e => e.parentCategory == null).map(m => m.name)
            if(_self.newSelectedCategory != null){
                _self.selectedSubCategories = _self.allCategories.filter(e => e.parentCategory === _self.newSelectedCategory).map(m => m.name);
            }
            _self.updateColorsByCategory()
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getById(){
    let _self = this;
    AdminApiService.getArticleById(_self.idToEdit)
        .then((response) => {
            _self.isHydratingArticleModel = true;
            const payload = Object.assign({}, response.data || {});
            payload.kpKind = normalizeEnumValue(payload.kpKind, KP_ENUM_KIND);
            payload.kpType = normalizeEnumValue(payload.kpType, KP_ENUM_TYPE);
            payload.kpCondition = normalizeEnumValue(payload.kpCondition, KP_ENUM_CONDITION);
            payload.kpCurrency = normalizeEnumValue(payload.kpCurrency, KP_ENUM_CURRENCY);
            payload.kpImmediateAvailable = normalizeYesNoValue(payload.kpImmediateAvailable);
            payload.kpExchange = normalizeYesNoValue(payload.kpExchange);
            payload.kpPriceFixed = normalizeYesNoValue(payload.kpPriceFixed);
            payload.kpLocalPickup = normalizeYesNoValue(payload.kpLocalPickup);
            payload.kpCourierDelivery = normalizeYesNoValue(payload.kpCourierDelivery);
            payload.kpCategoryId = normalizeNullableNumber(payload.kpCategoryId);
            payload.kpGroupId = normalizeNullableNumber(payload.kpGroupId);
            payload.kpPark = normalizeKpPark(payload.kpPark);
            payload.kpDescription = formatKpDescriptionForDisplay(payload.kpDescription);
            _self.model = Object.assign({}, _self.model, payload);
            _self.kpImportId = hasValue(payload.kpAdId) ? String(payload.kpAdId) : '';
            applyKpDefaultsIfNoAd(_self);
            if (!(response.data.code.length === 15 && /^\d+$/.test(response.data.code))) {
                this.selectedImeiItem = LocService.t('label_a_code_serial');
                this.imeiType = 'text'
            }
            _self.model.code = response.data.code;
            _self.newSelectedCategory = response.data.mainCategory;
            if(response.data.code.length < 15){
                _self.selectedImeiItem = LocService.t('label_a_code_serial')
            }
            if(_self.newSelectedCategory != null){
                _self.selectedSubCategories = _self.allCategories.filter(e => e.parentCategory === _self.newSelectedCategory).map(m => m.name);
            }
            console.log(_self.selectedSubCategories);
            // _self.visibleCategory = false;
            _self.newSelectedSubCategory = response.data.subCategory;

           _self.model.buyDate = _self.formatDate(_self.model.buyDate)
            _self.model.lastInventoryTimestamp = _self.formatDate(_self.model.lastInventoryTimestamp)
            _self.updateColorsByCategory()
            _self.$nextTick(() => {
                _self.isHydratingArticleModel = false;
            });
        })
        .catch(error => {
            _self.isHydratingArticleModel = false;
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function updateColorsByCategory(){
    let _self = this;
    let foundCategory = _self.allCategories.filter(e => e.name === _self.newSelectedCategory)
    if(foundCategory.length > 0){
        let cat = foundCategory[0];
        if(cat.color == null || cat.color.length === 0){
            _self.colorsByCategory = []
        }else{
            let c = cat.color.split(";").filter(s=> s != null && s.length > 0)
            _self.colorsByCategory = c;
        }

    }else{
        this.colorsByCategory = []
    }
}

function clear() {
    this.model.name = '';
    this.model.code = '';
    this.model.mainCategory = '';
    this.model.subCategory = '';
    this.model.addInfoMemory = '';
    this.model.color = '';
    this.model.comment = '';
    this.model.purchasePrice = 0;
    this.model.sellingPrice = 0;
    this.model.shortDescription = '';
    this.model.buyDate = null;
    this.model.lastInventoryTimestamp = null;

}

function addArticle() {
    if(this.selectedImeiItem === LocService.t('label_a_code')){
        if (this.model.code.length === 15 && /^\d+$/.test(this.model.code)) {
            // console.log("String ima tačno 15 cifara i sve su brojevi.");
        } else {
            swal( LocService.t('label_error'), LocService.t('label_imei_error'), 'error')
            return;
        }
    }else{
        if (this.model.code.length === 0){
            swal( LocService.t('label_error'), LocService.t('label_serial_number_error'), 'error')
            return;
        }
    }

    let _self = this;
    const payload = Object.assign({}, this.model);
    payload.buyDate = normalizeBuyDateForRequest(payload.buyDate);
    payload.kpDescription = formatKpDescriptionForRequest(payload.kpDescription, this.idToEdit);
    if(this.idToEdit != null){
        this.editArticle();
        return
    }
    payload.mainCategory = this.newSelectedCategory;
    payload.subCategory = this.newSelectedSubCategory;
    payload.makeScheduleItem = this.regularType === 0;
    payload.regularSupply = this.regularType === 1;
    _self.showLoading(true);
    AdminApiService.addArticle(payload)
        .then((response) => {
            _self.showLoading(false);
            const createdId = response != null && response.data != null ? response.data.createdId : null;
            if(response.data.id != null){
                _self.askToEdit(response.data.id)
            }else if(createdId != null){
                handleKpPostCreateDialog(_self, createdId);
            }else{

                let articleNumber = response.data.serialNumber != null ? ' - ' + String(response.data.serialNumber).padStart(6, '0') : ''
                swal( LocService.t('label_success'),LocService.t('label_article_added') + articleNumber,'success')
                // _self.$router.back()
            }
           // _self.clear();
        })
        .catch(error => {
            _self.showLoading(false);
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function handleKpPostCreateDialog(vm, createdId) {
    swal({
        title: LocService.t('label_success'),
        // text: LocService.t('label_kp_fill_after_create_question') + '\n' + '#' + createdId,
        html: '<div>' +
            LocService.t('label_kp_fill_after_create_question') +
            '</div><div style="margin-top:8px;font-weight:700;">#' + createdId + '</div>',
        type: 'question',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_kp_post_new'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#7f8ca5',
        confirmButtonText: LocService.t('label_kp_fill_now'),
        customClass: 'swal2-warning'
    }).then(function () {
        vm.$router.push({
            path: vm.$route.path,
            query: { id: createdId }
        });
        vm.idToEdit = createdId;
        vm.visibleStock = false;
        vm.title = LocService.t('label_update_article');
        vm.showKpPanel = false;
        vm.getById();
        vm.loadImagesForArticle();
        vm.loadKpCategories();
    }).catch(function () {});
}

function changeArticleInventory(){
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_to_update_inventory')  + " #"+ String(this.idToEdit).padStart(6, '0'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        let model = {
            id : _self.idToEdit,
            date: _self.$moment(_self.model.lastInventoryTimestamp).format('DD-MM-YYYY'),
        }
        AdminApiService.updateArticleInventory(model)
            .then((response) => {
                swal( LocService.t('label_success'),  LocService.t('label_article_inventory_success'), 'success')
                _self.getById()
            })
            .catch((error) => {
                console.log(error)
                swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function editArticle(updateExist){
    let _self = this;
    const requestModel = Object.assign({}, this.model);
    requestModel.id = this.idToEdit;
    requestModel.buyDate = normalizeBuyDateForRequest(requestModel.buyDate);
    requestModel.kpDescription = formatKpDescriptionForRequest(requestModel.kpDescription, requestModel.id);
    requestModel.mainCategory = this.newSelectedCategory;
    requestModel.subCategory = this.newSelectedSubCategory;
    requestModel.makeScheduleItem = false;
    if(updateExist == null){
        requestModel.regularSupply = false;
    }
    AdminApiService.updateArticle(requestModel)
        .then((response) => {
            _self.model.updateAlreadyExist = null
            swal( LocService.t('label_success'),LocService.t('label_article_updated'),'success')
            // _self.$router.back()
            // _self.clear();
        })
        .catch(error => {
            _self.model.updateAlreadyExist = null
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function deleteSaradnik(){
    this.model.companyPayment = null;
}

function getChipClass(item){
    if(this.newSelectedCategory === item){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function getChipClassRegularType(item){
    if(this.regularType === item.id){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedRegularType(item){
    return this.regularType === item.id
}

function getChipClassImei(item){
    if(this.selectedImeiItem === item){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedImei(item){
    return this.selectedImeiItem === item
}

function isSelected(item){
    return this.newSelectedCategory === item
}

function getChipClassSub(item){
    if(this.newSelectedSubCategory === item){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedColor(item){
    return this.model.color === item
}

function getColorClass(item){
    if(this.model.color === item){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedSub(item){
    return this.newSelectedSubCategory === item
}

function handleFileChange(event){
    let _self = this;
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
        _self.showCropImage(reader.result)
    };
    reader.readAsDataURL(file);
}


function showLoading(val){
    if(val){
        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_please_wait') + "</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {});
    }else{
        swal.close()
    }
}

async function recognizeFromImage(){
    let _self = this;
    // (A) GET HTML ELEMENTS
    const hSel = document.getElementById("select");

    // (B) CREATE ENGLISH TESSERACT WORKER
    const worker = await Tesseract.createWorker();
    await worker.loadLanguage("eng");
    await worker.initialize("eng");

    // (C) ON FILE SELECT - IMAGE TO TEXT
    hSel.onchange = async () => {
        _self.showLoading(true)
        const res = await worker.recognize(hSel.files[0]);
        _self.showLoading(false)
        let rows = res.data.text.split("\n").filter(e=> e.length > 0);
        if(rows.length > 0){
            _self.showChooseImeiDialog = true;
            _self.showChooseImeiOptions = rows;
        }
        this.$refs.fileInput.value = null;

    };
}

async function recognizeFromCrop(file){
    let _self = this;

    const worker = await Tesseract.createWorker();
    await worker.loadLanguage("eng");
    await worker.initialize("eng");

    _self.showLoading(true)
    const res = await worker.recognize(file);
    _self.showLoading(false)
    let rows = res.data.text.split("\n").map(m => m.replace(/\D/g, "")).filter(e=> e.length > 0);
    if(rows.length > 0){
        _self.showChooseImeiDialog = true;
        _self.showChooseImeiOptions = rows;
    }
    this.$refs.fileInput.value = null;
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('YYYY-MM-DD')
}


function openImagePicker(){
    if(this.$refs.imagesInput) this.$refs.imagesInput.click();
}

function ensureUploadSession(){
    // ako dodaješ novi artikal (idToEdit null), treba "session" da backend primi slike pa posle veže
    if(this.uploadSessionId) return this.uploadSessionId;
    this.uploadSessionId = 'tmp_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    return this.uploadSessionId;
}

async function onImagesSelected(e){
    const files = Array.from(e.target.files || []);
    if(files.length === 0) return;

    for (const file of files) {
        // optimistic thumb odmah
        const localId = 'local_' + Math.random().toString(36).slice(2);
        const previewUrl = URL.createObjectURL(file);

        const tempItem = {
            localId,
            url: previewUrl,
            uploading: true,
            progress: 0,
            serverId: null,
            isPrimary: false,
        };
        this.articleImages.unshift(tempItem);
        this.selectedImageLocalId = localId;
        // ako je prva slika, setuj kao primary odmah (vizuelno)
        if(!this.primaryImageLocalId) this.primaryImageLocalId = localId;

        try{
            const compressedFile = await compressImageForUpload(file);
            await this.uploadSingleImage(compressedFile, tempItem);
        }catch(err){
            // izbaci failed item (ili ostavi i obeleži)
            this.articleImages = this.articleImages.filter(i => i.localId !== localId);
            const msg =
                (err && err.data && err.data.localized_error_message)
                    ? err.data.localized_error_message
                    : LocService.t('label_upload_failed');

            swal(LocService.t('label_error'), msg, 'error');
        }
    }

    // reset input da može isti fajl opet
    if(this.$refs.imagesInput) this.$refs.imagesInput.value = null;

    // Važno: osveži slike sa servera odmah nakon upload batch-a
    // da svi dobiju serverId/imageOrder i da reorder kontrole budu dostupne bez refresh-a stranice.
    if (this.idToEdit != null) {
        await this.loadImagesForArticle();
    } else {
        this.getById();
    }
}

function compressImageForUpload(file) {
    if (!file || !file.type || String(file.type).indexOf('image/') !== 0) {
        return Promise.resolve(file);
    }

    const fileType = String(file.type).toLowerCase();
    if (fileType === 'image/gif' || fileType === 'image/svg+xml') {
        return Promise.resolve(file);
    }

    const QUALITY = 0.82;
    const TARGET_TYPE = 'image/jpeg';

    return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = function () {
            const img = new Image();
            img.onload = function () {
                try {
                    const srcWidth = img.naturalWidth || img.width;
                    const srcHeight = img.naturalHeight || img.height;
                    if (!srcWidth || !srcHeight) {
                        resolve(file);
                        return;
                    }

                    // Zadrzavamo originalne dimenzije (bez resize), kompresija ide samo preko kvaliteta.
                    const targetWidth = srcWidth;
                    const targetHeight = srcHeight;

                    const canvas = document.createElement('canvas');
                    canvas.width = targetWidth;
                    canvas.height = targetHeight;

                    const ctx = canvas.getContext('2d');
                    if (!ctx) {
                        resolve(file);
                        return;
                    }

                    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

                    canvas.toBlob(function (blob) {
                        if (!blob || blob.size <= 0) {
                            resolve(file);
                            return;
                        }

                        // Ako kompresija nije dala realnu korist, zadrži original.
                        if (blob.size >= file.size * 0.98) {
                            resolve(file);
                            return;
                        }

                        const baseName = (file.name || 'image').replace(/\.[^/.]+$/, '');
                        try {
                            const compressed = new File([blob], baseName + '.jpg', {
                                type: TARGET_TYPE,
                                lastModified: Date.now(),
                            });
                            resolve(compressed);
                        } catch (e) {
                            blob.name = baseName + '.jpg';
                            resolve(blob);
                        }
                    }, TARGET_TYPE, QUALITY);
                } catch (e) {
                    resolve(file);
                }
            };

            img.onerror = function () {
                resolve(file);
            };

            img.src = reader.result;
        };

        reader.onerror = function () {
            resolve(file);
        };

        reader.readAsDataURL(file);
    });
}

async function uploadSingleImage(file, tempItem){
    // bitno: ako imaš idToEdit (update mode) – veži direktno
    // ako nema – šalji uploadSessionId pa backend posle veže kad se kreira artikal
    const articleId = this.idToEdit;


    // primer: očekujem da vrati { id, url }
    const res = await AdminApiService.uploadArticleImage({
        articleId,
        file: file,
        onProgress: (percent) => { tempItem.progress = percent; }
    });

    tempItem.uploading = false;
    tempItem.progress = 100;
    const responseData = res && res.data ? res.data : {};
    tempItem.serverId = extractImageServerId(responseData);
    tempItem.url = extractImageUrl(responseData) || tempItem.url;
    tempItem.imageOrder = responseData && responseData.imageOrder != null ? responseData.imageOrder : null;

    // set primary server-side ako je trenutno primary
    if(this.primaryImageLocalId === tempItem.localId){
        await this.setPrimaryImage(tempItem, true);
    }
}

function extractImageServerId(payload){
    if(payload == null) return null;
    const direct = payload.id != null ? payload.id : payload.imageId;
    if(direct != null && ('' + direct).trim().length > 0) return direct;

    const nested = payload.data || payload.result || payload.item || null;
    if(nested == null) return null;

    const nestedDirect = nested.id != null ? nested.id : nested.imageId;
    if(nestedDirect != null && ('' + nestedDirect).trim().length > 0) return nestedDirect;
    return null;
}

function extractImageUrl(payload){
    if(payload == null) return null;
    if(payload.url != null && ('' + payload.url).trim().length > 0) return payload.url;

    const nested = payload.data || payload.result || payload.item || null;
    if(nested && nested.url != null && ('' + nested.url).trim().length > 0) return nested.url;
    return null;
}

async function setPrimaryImage(img, silent){
    this.selectedImageLocalId = img.localId; // kad postane primary, neka ostane prikazana
    this.primaryImageLocalId = img.localId;

    this.articleImages = this.articleImages.map(function(i){
        return Object.assign({}, i, {
            isPrimary: i.localId === img.localId
        });
    });

    // ako je još uploading, ne diraj server
    if(img.uploading || !img.serverId) return;

    try{
        await AdminApiService.setArticlePrimaryImage({
            articleId: this.idToEdit,
            imageId: img.serverId,
        });
    }catch(e){
        swal(LocService.t('label_error'), LocService.t('label_cannot_set_primary'), 'error');
    }
}

async function removeImage(img){
    let confirmed = false;
    await swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_delete_image'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        confirmed = true;
    }).catch(function () {});

    if (!confirmed) return;

    const localIdServerPart = (img && img.localId && ('' + img.localId).indexOf('srv_') === 0)
        ? ('' + img.localId).replace('srv_', '')
        : null;

    let imageServerId = img != null
        ? (img.serverId != null
            ? img.serverId
            : (img.id != null
                ? img.id
                : localIdServerPart))
        : null;

    // Fallback: ako upload response nije vratio id kako treba, osveži slike sa servera
    // i pokušaj da pronađeš odgovarajući server image id (najčešće po URL-u).
    if(!img.uploading && !imageServerId && this.idToEdit != null){
        try{
            await this.loadImagesForArticle();
            const matched = (this.articleImages || []).find((x) => {
                if(!x) return false;
                if(img.url && x.url && ('' + img.url) === ('' + x.url)) return true;
                if(img.localId && x.localId && ('' + img.localId) === ('' + x.localId)) return true;
                return false;
            });
            if(matched && matched.serverId != null){
                imageServerId = matched.serverId;
            }
        }catch (e){
            // tiho, ostaje fallback logika ispod
        }
    }

    if(!(img.uploading || !imageServerId)){
        try{
            await AdminApiService.deleteArticleImage({
                articleId: this.idToEdit,
                imageId: imageServerId,
                sessionId: this.idToEdit ? null : this.uploadSessionId
            });
        }catch(e){
            const msg = (e && e.data && e.data.localized_error_message) ? e.data.localized_error_message : LocService.t('label_delete_image_failed');
            swal(LocService.t('label_error'), msg, 'error');
            return;
        }
    }else if(!img.uploading && this.idToEdit != null){
        swal(LocService.t('label_error'), LocService.t('label_delete_image_failed'), 'error');
        return;
    }

    // optimistic UI nakon potvrde / server delete success
    const wasPrimary = (img.localId === this.primaryImageLocalId) || (img.serverId != null && ('srv_' + img.serverId) === this.primaryImageLocalId);
    this.articleImages = this.articleImages.filter(i => {
        if(img.localId && i.localId === img.localId) return false;
        if(imageServerId != null && i.serverId != null && Number(i.serverId) === Number(imageServerId)) return false;
        if(img.url && i.url && ('' + i.url) === ('' + img.url)) return false;
        return true;
    });

    if(this.articleImages.length === 0){
        this.primaryImageLocalId = null;
    }else if(wasPrimary){
        this.primaryImageLocalId = this.articleImages[0].localId;
        this.articleImages[0].isPrimary = true;
        // pokušaj server primary update
        await this.setPrimaryImage(this.articleImages[0], true);
    }

    if(this.idToEdit != null){
        await this.loadImagesForArticle();
    }
}

async function loadImagesForArticle(){
    if(!this.idToEdit) return;
    try{
        const res = await AdminApiService.getArticleImages(this.idToEdit);
        // očekujem: [{id, url, primary}]
        this.articleImages = (res.data || []).map(x => ({
            localId: 'srv_' + x.id,
            serverId: x.id,
            url: x.url,
            uploading: false,
            progress: 100,
            isPrimary: !!x.primaryImage,
            imageOrder: x.imageOrder != null ? x.imageOrder : null,
        }));

        const primary = this.articleImages.find(i => i.isPrimary) || this.articleImages[0];
        this.primaryImageLocalId = primary ? primary.localId : null;
        this.selectedImageLocalId = this.primaryImageLocalId;
        this.imageOrderDirty = false;
    }catch(e){
        // tiho
    }
}

function selectImage(img){
    if(!img) return;
    this.selectedImageLocalId = img.localId;
}

function onMainImageClick(){
    // ako ima slika -> zoom, ako nema -> picker
    if(this.selectedImage && this.selectedImage.url){
        this.openZoomDialog(this.selectedImage);
    }else{
        this.openImagePicker();
    }
}

function moveImageLeft(img){
    if(!this.canReorderImages || !img) return;
    const currentIndex = this.articleImages.findIndex((x) => x.localId === img.localId);
    if(currentIndex <= 0) return;
    const prev = this.articleImages[currentIndex - 1];
    this.articleImages.splice(currentIndex - 1, 2, img, prev);
    this.imageOrderDirty = true;
}

function moveImageRight(img){
    if(!this.canReorderImages || !img) return;
    const currentIndex = this.articleImages.findIndex((x) => x.localId === img.localId);
    if(currentIndex < 0 || currentIndex >= this.articleImages.length - 1) return;
    const next = this.articleImages[currentIndex + 1];
    this.articleImages.splice(currentIndex, 2, next, img);
    this.imageOrderDirty = true;
}

async function saveImagesOrder(){
    if(!this.canReorderImages || !this.imageOrderDirty || this.imageOrderSaving) return;
    this.imageOrderSaving = true;

    const payload = this.articleImages.map((img, index) => ({
        id: Number(img.serverId),
        orderNumber: index + 1,
    }));

    try{
        await AdminApiService.saveArticleImagesOrder(payload);
        this.imageOrderDirty = false;
        swal(LocService.t('label_success'), LocService.t('label_image_order_saved'), 'success');
        await this.loadImagesForArticle();
    }catch(e){
        swal(LocService.t('label_error'), LocService.t('label_image_order_save_failed'), 'error');
        await this.loadImagesForArticle();
    }finally{
        this.imageOrderSaving = false;
    }
}

async function downloadAllImagesZip() {
    if (!this.idToEdit || this.downloadImagesZipLoading || this.isAnyUploading) return;
    if (!this.articleImages || this.articleImages.length === 0) {
        swal(LocService.t('label_error'), LocService.t('label_no_data'), 'error');
        return;
    }

    this.downloadImagesZipLoading = true;
    try {
        const zip = new JSZip();
        const folder = zip.folder('article-' + this.idToEdit);
        const images = this.articleImages.slice();

        for (let i = 0; i < images.length; i++) {
            const img = images[i];
            if (!img || img.serverId == null) continue;
            const proxyRes = await AdminApiService.getArticleImageProxy(img.serverId);
            const headers = proxyRes && proxyRes.headers ? proxyRes.headers : {};
            const contentDisposition = headers['content-disposition'] || headers['Content-Disposition'];
            const contentType = headers['content-type'] || headers['Content-Type'];

            let fileName = getFileNameFromContentDisposition(contentDisposition);
            if (!hasValue(fileName)) {
                const extension = extensionFromContentType(contentType) || 'jpg';
                fileName = 'image-' + img.serverId + '.' + extension;
            }
            fileName = sanitizeFileName(fileName, 'image-' + img.serverId);
            folder.file(fileName, proxyRes.data);
        }

        const zipBlob = await zip.generateAsync({ type: 'blob' });
        const zipName = 'article-' + this.idToEdit + '-images.zip';
        const downloadUrl = window.URL.createObjectURL(zipBlob);
        const anchor = document.createElement('a');
        anchor.href = downloadUrl;
        anchor.download = zipName;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        window.URL.revokeObjectURL(downloadUrl);
    } catch (e) {
        const backendMessage = e && e.data && e.data.localized_error_message ? e.data.localized_error_message : LocService.t('label_error');
        swal(LocService.t('label_error'), backendMessage, 'error');
    } finally {
        this.downloadImagesZipLoading = false;
    }
}

function openZoomDialog(img){
    if(!img || !img.url) return;

    swal({
        title: '',
        html:
            '<div class="zoom-wrap">' +
            '  <img id="zoomImg" class="zoom-img" src="'+ img.url +'" />' +
            '</div>' +
            '<div class="zoom-hint">' + LocService.t('label_click_image_to_zoom') + '</div>',
        showConfirmButton: false,
        showCloseButton: true,
        background: 'rgba(0,0,0,0.0)',
        customClass: 'swal-zoom-popup',
        didOpen: function(){
            var el = document.getElementById('zoomImg');
            if(!el) return;
            el.addEventListener('click', function(){
                if(el.classList.contains('zoomed')){
                    el.classList.remove('zoomed');
                }else{
                    el.classList.add('zoomed');
                }
            });
        }
    });
}

function toggleKpPanel() {
    this.showKpPanel = !this.showKpPanel;
}

function toggleKpMoreDetails() {
    this.showKpMoreDetails = !this.showKpMoreDetails;
}

function loadKpCategories() {
    let _self = this;
    _self.kpLoadingCategories = true;

    // OVO su backend endpointi koje smo napravili:
    // GET /api/kp/categories
    AdminApiService.getKpCategories()
        .then((response) => {
            _self.kpCategories = response.data || [];
        })
        .catch(() => {
            _self.kpCategories = [];
        })
        .finally(() => {
            _self.kpLoadingCategories = false;
        });
}

function loadKpGroups(categoryId) {
    let _self = this;
    if (categoryId == null) {
        _self.kpGroups = [];
        return;
    }

    _self.kpLoadingGroups = true;

    // GET /api/kp/categories/{categoryId}/groups
    return AdminApiService.getKpGroups(categoryId)
        .then((response) => {
            _self.kpGroups = response.data || [];
            if (_self.model && _self.model.kpGroupId != null) {
                const exists = _self.kpGroups.some((g) => Number(g.id) === Number(_self.model.kpGroupId));
                if (!exists) {
                    _self.model.kpGroupId = null;
                }
            }
            _self.tryAutoSelectKpGroupByMainCategory(_self);
        })
        .catch(() => {
            _self.kpGroups = [];
        })
        .finally(() => {
            _self.kpLoadingGroups = false;
        });
}

function tryAutoSelectKpGroupByMainCategory(vm) {
    if (!vm || !vm.model) return;
    if (vm.model.kpGroupId != null && String(vm.model.kpGroupId).trim().length > 0) return;

    const mainCategory = vm.model.mainCategory || vm.newSelectedCategory;
    if (!hasValue(mainCategory)) return;

    const normalizedMainCategory = String(mainCategory).toLowerCase().trim();
    if (normalizedMainCategory.length === 0) return;

    const groups = Array.isArray(vm.kpGroups) ? vm.kpGroups : [];
    const found = groups.find((g) => {
        const groupName = g && g.name != null ? String(g.name).toLowerCase() : '';
        return groupName.indexOf(normalizedMainCategory) !== -1;
    });

    if (found && found.id != null && String(found.id).trim().length > 0) {
        vm.model.kpGroupId = found.id;
    }
}

function publishKpAd() {
    if (this.idToEdit == null) {
        swal(LocService.t('label_error'), LocService.t('label_kp_save_article_before_publish'), 'error');
        return;
    }
    if (this.kpActionLoading) return;

    let _self = this;
    _self.kpActionLoading = true;
    _self.kpActionType = 'publish';
    const savePayload = buildKpSavePayload(this);

    AdminApiService.updateArticle(savePayload)
        .then(() => {
            return AdminApiService.publishKpAd(_self.idToEdit);
        })
        .then(() => {
            _self.getById();
            swal(LocService.t('label_success'), LocService.t('label_kp_publish_success'), 'success');
        })
        .catch((error) => {
            const message = resolveBackendErrorMessage(error, LocService.t('label_kp_publish_error'));
            swal(LocService.t('label_error'), message, 'error');
        })
        .finally(() => {
            _self.kpActionLoading = false;
            _self.kpActionType = null;
        });
}

function importKpAdFromManualId() {
    return importKpAdFromManualIdWithMode.call(this, true);
}

function importKpAdIdOnlyFromManualId() {
    return importKpAdFromManualIdWithMode.call(this, false);
}

function importKpAdFromManualIdWithMode(shouldUseDataFromKp) {
    if (this.idToEdit == null) {
        swal(LocService.t('label_error'), LocService.t('label_kp_save_article_before_publish'), 'error');
        return;
    }
    if (this.kpImportLoading || this.kpActionLoading) return;

    const raw = this.kpImportId != null ? String(this.kpImportId).trim() : '';
    if (raw.length === 0) {
        swal(LocService.t('label_error'), LocService.t('label_kp_import_required'), 'error');
        return;
    }
    if (!/^\d+$/.test(raw) || Number(raw) <= 0) {
        swal(LocService.t('label_error'), LocService.t('label_kp_import_invalid'), 'error');
        return;
    }

    const _self = this;
    _self.kpImportLoading = true;

    AdminApiService.importKpAd({
        articleId: Number(_self.idToEdit),
        kpId: Number(raw),
        shouldUseDataFromKp: shouldUseDataFromKp === true,
    })
        .then((response) => {
            const payload = response && response.data ? response.data : {};
            const synced = payload.imagesSynced != null ? Number(payload.imagesSynced) : 0;
            const usedDataFromKp = payload.usedDataFromKp !== false;
            _self.getById();
            _self.loadImagesForArticle();
            if (usedDataFromKp) {
                swal(LocService.t('label_success'), LocService.t('label_kp_import_success') + ' (' + synced + ')', 'success');
            } else {
                swal(LocService.t('label_success'), LocService.t('label_kp_import_id_only_success'), 'success');
            }
        })
        .catch((error) => {
            const message = resolveBackendErrorMessage(error, LocService.t('label_kp_import_error'));
            swal(LocService.t('label_error'), message, 'error');
        })
        .finally(() => {
            _self.kpImportLoading = false;
        });
}

function updateKpAdAction() {
    if (this.idToEdit == null) {
        swal(LocService.t('label_error'), LocService.t('label_kp_save_article_before_update'), 'error');
        return;
    }
    if (this.kpActionLoading) return;

    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_kp_confirm_update'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        _self.kpActionLoading = true;
        _self.kpActionType = 'update';

        const savePayload = buildKpSavePayload(_self);

        AdminApiService.updateArticle(savePayload)
            .then(() => {
                return AdminApiService.updateKpAd(_self.idToEdit);
            })
            .then(() => {
                _self.getById();
                swal(LocService.t('label_success'), LocService.t('label_kp_update_success'), 'success');
            })
            .catch((error) => {
                const message = resolveBackendErrorMessage(error, LocService.t('label_kp_update_error'));
                swal(LocService.t('label_error'), message, 'error');
            })
            .finally(() => {
                _self.kpActionLoading = false;
                _self.kpActionType = null;
            });
    }).catch(function () {});
}

function unlinkKpAd() {
    if (this.idToEdit == null || this.kpActionLoading) return;
    let _self = this;

    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_kp_confirm_unlink'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        _self.kpActionLoading = true;
        _self.kpActionType = 'unlink';

        AdminApiService.unlinkKpAd(_self.idToEdit)
            .then(() => {
                _self.getById();
                swal(LocService.t('label_success'), LocService.t('label_kp_unlink_success'), 'success');
            })
            .catch((error) => {
                const message = resolveBackendErrorMessage(error, LocService.t('label_kp_unlink_error'));
                swal(LocService.t('label_error'), message, 'error');
            })
            .finally(() => {
                _self.kpActionLoading = false;
                _self.kpActionType = null;
            });
    }).catch(function () {});
}

function applyKpDefaultsIfNoAd(vm) {
    if (hasValue(vm.model.kpAdId)) return;

    vm.model.kpKind = 'goods';
    if (vm.model.kpCategoryId == null) vm.model.kpCategoryId = 23;
    if (!hasValue(vm.model.kpType)) vm.model.kpType = 'sell';
    if (!hasValue(vm.model.kpCondition)) vm.model.kpCondition = 'as-new';
    if (!hasValue(vm.model.kpCurrency)) vm.model.kpCurrency = 'eur';
    if (!hasValue(vm.model.kpImmediateAvailable)) vm.model.kpImmediateAvailable = 'yes';
    if (!hasValue(vm.model.kpExchange)) vm.model.kpExchange = 'yes';
    if (!hasValue(vm.model.kpPriceFixed)) vm.model.kpPriceFixed = 'no';
    if (!hasValue(vm.model.kpLocalPickup)) vm.model.kpLocalPickup = 'yes';
    if (!hasValue(vm.model.kpCourierDelivery)) vm.model.kpCourierDelivery = 'yes';
    if (!hasValue(vm.model.kpDescription)) vm.model.kpDescription = KP_DEFAULT_DESCRIPTION_TEMPLATE;
    if (!hasValue(vm.model.kpPrice)) {
        vm.model.kpPrice = 0;
    }

    if (typeof vm.loadKpGroups === 'function' && vm.model.kpCategoryId != null) {
        vm.loadKpGroups(vm.model.kpCategoryId);
    }
}

function buildKpShareUrl() {
    if (!hasValue(this.model.kpShareUrl)) return '';
    const url = String(this.model.kpShareUrl).trim();
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    return KP_SHARE_BASE_URL + url.replace(/^\/+/, '');
}

function copyKpShareUrl() {
    const fullUrl = this.buildKpShareUrl();
    if (!hasValue(fullUrl)) {
        swal(LocService.t('label_error'), LocService.t('label_kp_share_url_missing'), 'error');
        return;
    }

    const onSuccess = () => swal(LocService.t('label_success'), LocService.t('label_kp_share_url_copied'), 'success');
    const onFailure = () => swal(LocService.t('label_error'), fullUrl, 'error');

    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(fullUrl).then(onSuccess).catch(onFailure);
        return;
    }

    try {
        const el = document.createElement('textarea');
        el.value = fullUrl;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        onSuccess();
    } catch (e) {
        onFailure();
    }
}

function buildKpSavePayload(vm) {
    const savePayload = Object.assign({}, vm.model, {
        id: vm.idToEdit,
        mainCategory: vm.newSelectedCategory,
        subCategory: vm.newSelectedSubCategory,
        makeScheduleItem: false,
        regularSupply: false,
    });
    if (!hasValue(savePayload.kpAdId)) {
        applyKpDefaultsIfNoAd({ model: savePayload });
    }
    savePayload.kpKind = 'goods';
    savePayload.kpOwner = 'Aleksandar_Ns_';
    savePayload.kpLocationId = 16;
    savePayload.kpPhone = '+381654389483';
    delete savePayload.kpPark;
    delete savePayload.kpPostDate;
    savePayload.buyDate = normalizeBuyDateForRequest(savePayload.buyDate);
    savePayload.kpDescription = formatKpDescriptionForRequest(savePayload.kpDescription, savePayload.id);
    return savePayload;
}

function getKpPostDateDisplay() {
    const parsed = parseDateValue(this.model ? this.model.kpPostDate : null);
    if (parsed == null) return '/';
    if (this.$moment) return this.$moment(parsed).format('DD-MM-YYYY');
    const dd = String(parsed.getDate()).padStart(2, '0');
    const mm = String(parsed.getMonth() + 1).padStart(2, '0');
    const yyyy = parsed.getFullYear();
    return dd + '-' + mm + '-' + yyyy;
}

function getKpAdAgeDaysDisplay() {
    const days = getDifferenceDaysFromToday(this.model ? this.model.kpPostDate : null);
    if (days == null) return '/';
    return String(days) + 'd';
}

function parkKpAd() {
    if (this.idToEdit == null || this.kpActionLoading) return;
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_kp_confirm_park'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        _self.kpActionLoading = true;
        _self.kpActionType = 'park';

        AdminApiService.parkKpAd(_self.idToEdit)
            .then(() => {
                _self.getById();
                swal(LocService.t('label_success'), LocService.t('label_kp_park_success'), 'success');
            })
            .catch((error) => {
                const message = resolveBackendErrorMessage(error, LocService.t('label_kp_park_error'));
                swal(LocService.t('label_error'), message, 'error');
            })
            .finally(() => {
                _self.kpActionLoading = false;
                _self.kpActionType = null;
            });
    }).catch(function () {});
}

function unparkKpAd() {
    if (this.idToEdit == null || this.kpActionLoading) return;
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_kp_confirm_unpark'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        _self.kpActionLoading = true;
        _self.kpActionType = 'unpark';

        AdminApiService.unparkKpAd(_self.idToEdit)
            .then(() => {
                _self.getById();
                swal(LocService.t('label_success'), LocService.t('label_kp_unpark_success'), 'success');
            })
            .catch((error) => {
                const message = resolveBackendErrorMessage(error, LocService.t('label_kp_unpark_error'));
                swal(LocService.t('label_error'), message, 'error');
            })
            .finally(() => {
                _self.kpActionLoading = false;
                _self.kpActionType = null;
            });
    }).catch(function () {});
}

function deleteKpAd() {
    if (this.idToEdit == null || this.kpActionLoading) return;
    let _self = this;

    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_kp_confirm_delete'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        _self.kpActionLoading = true;
        _self.kpActionType = 'delete';

        AdminApiService.deleteKpAd(_self.idToEdit)
            .then(() => {
                _self.getById();
                swal(LocService.t('label_success'), LocService.t('label_kp_delete_success'), 'success');
            })
            .catch((error) => {
                const message = resolveBackendErrorMessage(error, LocService.t('label_kp_delete_error'));
                swal(LocService.t('label_error'), message, 'error');
            })
            .finally(() => {
                _self.kpActionLoading = false;
                _self.kpActionType = null;
            });
    }).catch(function () {});
}



// WEBPACK FOOTER //
// ./src/components/Article/Add/AddArticle.js